import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SharedDataService {
  private logoutInitiated$ = new BehaviorSubject<boolean>(false);

  // Getter to check if logout has been initiated
  isLogoutInitiated(): boolean {
    return this.logoutInitiated$.value;
  }

  // Mark logout as initiated
  setLogoutInitiated(value: boolean): void {
    this.logoutInitiated$.next(value);
  }
}
